<script setup>
import { computed } from 'vue'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps({
  large: {
    type: Boolean,
    default: false,
  },
})

const wordClass = computed(() =>
  props.large ? 'text-2xl sm:text-3xl' : 'text-lg sm:text-xl',
)
</script>

<template>
  <span
    class="inline-flex items-center gap-2 shrink-0"
    role="img"
    aria-label="AskBro"
    v-bind="$attrs"
  >
    <img
      src="/images/askbro-logo.svg"
      alt=""
      width="66"
      height="102"
      decoding="async"
      class="h-full w-auto max-h-full object-contain object-left pointer-events-none select-none"
    />
    <span
      class="font-semibold tracking-tight leading-none text-primary-900 dark:text-white"
      :class="wordClass"
      aria-hidden="true"
    >
      AskBro
    </span>
  </span>
</template>
